import gql from "graphql-tag"

import { useFormMutation } from "hooks/useFormMutation"
import { START_JOURNEY_USER_FRAGMENT } from "graphql/queries/user"
import { StartQuizMutation, StartQuizMutationVariables } from "typings/types"

const START_QUIZ_MUTATION = gql`
  mutation StartQuiz($params: StartQuizInJourneyParams!) {
    startQuizInJourney(params: $params) {
      ...StartJourneyUserFragment
    }
  }
  ${START_JOURNEY_USER_FRAGMENT}
`

export const useStartQuiz = () => useFormMutation<StartQuizMutation, StartQuizMutationVariables>(START_QUIZ_MUTATION)
